import React from 'react'
import MySiteMeta from './MySiteMeta'

function GetPropertyValue(obj1, dataToRetrieve) {
    return dataToRetrieve
      .split('.') // split string based on `.`
      .reduce(function(o, k) {
        console.log('o=',o)
        console.log('k=',k)
        return o && o[k]; // get inner property if `o` is defined else get `o` and return
      }, obj1) // set initial value as object
  }

const SiteMeta = ({ ...props }) => {
  //   const data2 = useMySiteMetadata()
  //   const { disclaimer } = useMySiteMetadata()
  //   const data2 = MySiteMeta()
  const metaData = MySiteMeta()
  const fieldName = props.field
//   const data = metaData[fieldName]

  console.log(fieldName)
  const data = GetPropertyValue(metaData, fieldName)
//   console.log(data)

  return <>{data}</>
}

export default SiteMeta
